<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headeracknow01" class="chapter" epub:type="acknowledgments" id="acknow" role="doc-acknowledgments">
<header id="headeracknow01">
<h1 class="ctfm"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><span aria-label="ix" class="page" id="pix" role="doc-pagebreak"></span><a class="xref" href="#/wsutvmgoodplace0008#racknow">Acknowledgments</a></h1>
</header>
<p class="pf"><span class="dropcap">E</span>ndless gratitude for those who helped this book be, including Stacey Abbott, for early advice on the process; the Science Fiction and Fantasy section of the Southwest Popular and American Culture Association, for discussion and ideas; Tamy Burnett, for helping turn an offhanded comment during a panel into what would become the book’s first chapter; Kristopher Woofter, for encouragement and discussion; Marie Sweetman, for editorial prowess and thoughtfulness; and Carol Giannini, for support.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmgoodplace-0009.vue?2dffb48c